import { useEffect, useState, type RefObject } from 'react';

export function useIsClamped(ref: RefObject<HTMLElement | null>, content: unknown) {
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const check = () => setIsClamped(el.scrollHeight > el.clientHeight);
    check();

    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(check) : null;
    observer?.observe(el);

    return () => observer?.disconnect();
  }, [ref, content]);

  return isClamped;
}
